import type { InjectionKey, Ref } from 'vue'

/**
 * Provide/inject contract used by `CoreForm` and the `Core*Field` components.
 *
 * - Registration is optional: fields still work outside `CoreForm`.
 * - `submitted` is used to decide when to surface validation messages (e.g. show
 *   errors after submit, while keeping initial render calm).
 */
export type CoreFormFieldHandle = {
  key: string
  validate: () => Promise<string[]>
  resetValidation: () => void
}

export type CoreFormContext = {
  submitted: Ref<boolean>
  registerField: (handle: CoreFormFieldHandle) => () => void
}

export const coreFormKey: InjectionKey<CoreFormContext> = Symbol('coreForm')
